import View from './FormForgotPassword';
import enhancer from './FormForgotPassword.enhancer';

export default enhancer(View);
